const productEnrichmentRoutes = [
  {
    path: "/products/enrichments",
    name: "products.enrichments.index",
    component: () =>
      import("@/modules/Products/views/ProductEnrichmentList.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Enriquecimento de Produtos",
      breadcrumb: [
        {
          text: "Enrichments",
          active: true,
        },
      ],
    },
  },
  {
    path: "/products/enrichments/componentes",
    name: "products.enrichments.user-instructions",
    component: () =>
      import(
        "@/modules/Products/views/ProductEnrichmentUserInstructionList.vue"
      ),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Regras de Enriquecimento",
      breadcrumb: [
        {
          text: "Enriquecimento de Produtos",
          to: "/products/enrichments",
        },
        {
          text: "Instruções",
          active: true,
        },
      ],
    },
  },
];

const productClusterRoutes = [
  {
    path: "/products/clusters",
    name: "product-clusters.index",
    component: () => import("@/modules/Products/views/ProductClusterList.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Grupos de Produtos",
      breadcrumb: [
        { text: "Produtos", active: false, to: "/products" },
        { text: "Grupos de Produtos", active: true },
      ],
    },
  },
  {
    path: "/products/clusters/new",
    name: "product-clusters.new",
    component: () => import("@/modules/Products/views/ProductClusterForm.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Novo Grupo de Produtos",
      breadcrumb: [
        { text: "Grupos de Produtos", active: false, to: "/products/clusters" },
        { text: "Novo", active: true },
      ],
    },
  },
  {
    path: "/products/clusters/:uuid/edit",
    name: "product-clusters.edit",
    component: () => import("@/modules/Products/views/ProductClusterForm.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Editar Grupo de Produtos",
      breadcrumb: [
        { text: "Grupos de Produtos", active: false, to: "/products/clusters" },
        { text: "Editar", active: true },
      ],
    },
  },
  {
    path: "/products/clusters/:uuid/actions",
    name: "product-clusters.actions",
    component: () => import("@/modules/Products/views/ProductClusterActions.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Ações do Grupo de Produtos",
      breadcrumb: [
        { text: "Grupos de Produtos", active: false, to: "/products/clusters" },
        { text: "Ações", active: true },
      ],
    },
  },
];

export default [...productEnrichmentRoutes, ...productClusterRoutes];
